export enum CustomerType {
    INDIVIDUAL = 'INDIVIDUAL',
    CORPORATE = 'CORPORATE'
}